/**
 * Auto-redirect utility for unauthenticated users
 * Handles automatic OAuth2 redirection when no valid token is found
 */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { initiateOAuth2Flow } from './oauth2';
/**
 * Automatically redirect unauthenticated users to OAuth2 login flow
 * This function should be called when no valid authentication token is found
 * 
 * @param config Auto-redirect configuration options
 * @returns Promise that resolves when redirect is initiated or skipped
 */ export function handleAutoRedirect() {
    return _handleAutoRedirect.apply(this, arguments);
}
function _handleAutoRedirect() {
    _handleAutoRedirect = _async_to_generator(function() {
        var config, _config_provider, provider, _config_authServerUrl, authServerUrl, _config_redirectUri, redirectUri, _config_skipRedirect, skipRedirect, error;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    config = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    _config_provider = config.provider, provider = _config_provider === void 0 ? 'kakao' : _config_provider, _config_authServerUrl = config.authServerUrl, authServerUrl = _config_authServerUrl === void 0 ? typeof window !== 'undefined' ? window.location.origin : 'https://auth.ugot.uk' : _config_authServerUrl, _config_redirectUri = config.redirectUri, redirectUri = _config_redirectUri === void 0 ? typeof window !== 'undefined' ? "".concat(window.location.origin, "/oauth2/redirect") : undefined : _config_redirectUri, _config_skipRedirect = config.skipRedirect, skipRedirect = _config_skipRedirect === void 0 ? false : _config_skipRedirect;
                    // Skip redirect if explicitly disabled or not in browser environment
                    if (skipRedirect || typeof window === 'undefined') {
                        console.log('[AutoRedirect] Skipping auto-redirect');
                        return [
                            2
                        ];
                    }
                    console.log('[AutoRedirect] 비인증 사용자 자동 OAuth 리다이렉트 시작', {
                        provider: provider,
                        authServerUrl: authServerUrl,
                        redirectUri: redirectUri
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    // 기본 OAuth2 플로우 시작 (언어 파라미터 자동 포함)
                    return [
                        4,
                        initiateOAuth2Flow(provider, {
                            authServerUrl: authServerUrl,
                            redirectUri: redirectUri
                        })
                    ];
                case 2:
                    _state.sent();
                    console.log('[AutoRedirect] OAuth2 리다이렉트 성공적으로 시작됨');
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error('[AutoRedirect] OAuth 리다이렉트 실패:', error);
                    throw error;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _handleAutoRedirect.apply(this, arguments);
}
/**
 * Check if auto-redirect should be performed based on current URL and conditions
 * This can be used to prevent redirect loops or skip redirect on certain pages
 * 
 * @param currentPath Current URL path (default: window.location.pathname)
 * @returns boolean indicating whether auto-redirect should be performed
 */ export function shouldPerformAutoRedirect(currentPath) {
    if (typeof window === 'undefined') {
        return false;
    }
    var path = currentPath || window.location.pathname;
    // Skip redirect on OAuth callback pages to prevent loops
    if (path.includes('/oauth2/redirect') || path.includes('/oauth2/callback')) {
        console.log('[AutoRedirect] Skipping redirect - OAuth callback page');
        return false;
    }
    // Skip redirect on logout pages
    if (path.includes('/logout') || path.includes('/bye')) {
        console.log('[AutoRedirect] Skipping redirect - Logout page');
        return false;
    }
    return true;
}
